import {FC, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {Toaster} from "react-hot-toast";

import clsx from "clsx";
import {AppDispatch} from "../../../redux/reducer/store";

import LimitSelect from "../../custom/limitSelect/limitSelect";
import Pagination from "../../pagination/pagination";
import Loader from "../../custom/loader/loader";
import {formatReports} from '../../../utils/formatReports';

import '../table.scss';
import styles from "./consolidatedbudget.module.scss";
import {IUserOptions} from "../../../types/interfaces";
import {actionGetConsolidatedBudgetFilters, actionGetConsolidatedBudgetProjects} from "../../../redux/action/consolidatedbudget/actionConsolidatedBudget";
import CustomMultiSelect from "../../custom/customMultiSelect/customMultiSelect";
import {IProjestListOptions} from "../../../types/projectsInterface";
import {formatDateWithDots} from "../../../utils/formatDate";
import {
    reducerConsolidatedBudgetInputValues,
    reducerSelectedProjects,
    reducerSelectedProjectsId,
    reducerSetCurrentConsolidatedBudget
} from "../../../redux/reducer/consolidatedbudget/reducers/reducerConsolidatedBudget";


const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableConsolidatedBudget: FC = () => {
    const dispatch = useDispatch<AppDispatch>();
    const {
        data,
        limit,
        count,
        checkboxes,
        totalEmps,
        totalPoses,
        totalRoutes,
        projectsInputValues,
        selectedProjectsId,
        managersOptions,
    } = useSelector((state: any) => state.consolidatedbudget.projects);
    const {isOpenSidebar} = useSelector(
        (state: IUserOptions) => state.user.user
    );
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [startPage, setStartPage] = useState<number>(1);
    const [isPending, setIsPending] = useState<boolean>(true);
    const {claims} = useSelector((state: IUserOptions) => state.user.user.data);
    const [isHeaderCheckboxChecked, setIsHeaderCheckboxChecked] = useState<boolean>(false);
    const [isCheckedRows, setIsCheckedRows] = useState<boolean[]>(checkboxes);

    const actualLimit =
        JSON.parse(localStorage.getItem("pageLimit") as string) || limit;

    const handleChangeLimits = (option: { value: number }) => {
        handleChange(option.value, 1);
        resetPages();
    };

    const handleChange = (newLimit: number, newPage: number) => {
        setIsPending(true);
        dispatch(actionGetConsolidatedBudgetProjects(newLimit, newPage)).then(() => {
            setIsPending(false);
        });
        localStorage.setItem("pageLimit", JSON.stringify(newLimit));
    };

    const resetPages = () => {
        setCurrentPage(1);
        setStartPage(1);
    };

    const handleProjectClick = (el: IProjestListOptions) => {
        dispatch(reducerSetCurrentConsolidatedBudget({project: [el.project]}));
    };

    const checkboxList = (check: boolean) => {
        const updatedCheckedRows =
            data && data.reduce((acc: boolean[], project: IProjestListOptions) => {
                     const projectId = project.project?.id;
                     acc[projectId] = check;
                     return acc;
                 }, {});
        dispatch(reducerSelectedProjectsId(formatReports(updatedCheckedRows)));
        setIsCheckedRows(updatedCheckedRows);
    };

    const handleHeaderCheckboxChange = () => {
        setIsHeaderCheckboxChecked(!isHeaderCheckboxChecked);
        if (isHeaderCheckboxChecked) {
            checkboxList(false);
        }
    };

    const handleRowCheckboxChange = (el: IProjestListOptions) => {
        const projectId = el.project.id;
        setIsCheckedRows((prevCheckedRows: boolean[]) => ({
            ...prevCheckedRows,
            [projectId]: !prevCheckedRows[projectId],
        }));
        const updatedSelectedProjects = formatReports({
                                                          ...isCheckedRows,
                                                          [projectId]: !isCheckedRows[projectId],
                                                      });
        dispatch(reducerSelectedProjectsId(updatedSelectedProjects));
        dispatch(reducerSelectedProjects(el));
        setIsHeaderCheckboxChecked(updatedSelectedProjects.length === data.length);
    };

    useEffect(() => {
        dispatch(actionGetConsolidatedBudgetProjects(actualLimit, currentPage)).then(() => {
            setIsPending(false);
        });
    }, [actualLimit, dispatch, currentPage]);

    useEffect(() => {
        dispatch(actionGetConsolidatedBudgetFilters());
    }, [dispatch]);

    useEffect(() => {
        if (selectedProjectsId && !selectedProjectsId.length) {
            setIsCheckedRows(data && checkboxes);
            setIsHeaderCheckboxChecked(false);
        }
    }, [checkboxes, data, selectedProjectsId]);

    useEffect(() => {
        if (data) {
            checkboxList(false);
        }
        // eslint-disable-next-line
    }, [data]);

    useEffect(() => {
        if (isHeaderCheckboxChecked && data) {
            checkboxList(isHeaderCheckboxChecked);
        }
        // eslint-disable-next-line
    }, [isHeaderCheckboxChecked, data]);

    return (
        <>
            <div className="loader__wrapper">{isPending && <Loader/>}</div>
            <div
                className={clsx(JSON.parse(IS_VISIBLE_SIDEBAR as string) && isOpenSidebar && "active__table", !isOpenSidebar && "closed__table", "table")}>
                <Toaster position="top-center" toastOptions={{duration: 5000}}/>
                <div className={styles.table}>
                    <div className={styles.table__wrp}>
                        <table>
                            <thead>
                            <tr>
                                <th className="reports__checkbox_block">
                                    <input
                                        onChange={handleHeaderCheckboxChange}
                                        checked={isHeaderCheckboxChecked}
                                        type="checkbox"
                                    />

                                </th>
                                <th>
                                    <span className="filter__title">Наименование</span>
                                </th>
                                <th>
                                    <span className="filter__title">Сотрудников</span>
                                </th>
                                <th>
                                    <span className="filter__title">Точек</span>
                                </th>
                                <th>
                                    <span className="filter__title">Маршрутов</span>
                                </th>
                                <th>
                                    <div className="routes__multiselect_block">
                                        <CustomMultiSelect
                                            setLoading={setIsPending}
                                            reducer={reducerConsolidatedBudgetInputValues}
                                            inputValues={projectsInputValues}
                                            action={actionGetConsolidatedBudgetProjects}
                                            options={managersOptions}
                                            isShowPlaceholder={true}
                                            resetPages={resetPages}
                                            pageName="routes"
                                            placeholder="Менеджер"
                                            name="managers"
                                            limit={limit}
                                        />
                                    </div>
                                </th>
                                <th>
                                    <span className="filter__title">Активирован</span>
                                </th>
                            </tr>
                            </thead>

                            <tbody>
                            {data.map((el: IProjestListOptions, index: number) => (
                                <tr key={index}>
                                    <td>
                                        {claims.includes("analytics:consolidatedbudget:view") && (
                                            <input
                                                onChange={() => handleRowCheckboxChange(el)}
                                                checked={(isCheckedRows && isCheckedRows[el.project.id]) || false}
                                                className="relative__elem"
                                                type="checkbox"
                                            />
                                        )}
                                    </td>
                                    <td>
                                        <Link
                                            to={`/projects/${el?.project.id}/info`}
                                            onClick={() => {
                                                handleProjectClick(el);
                                            }}
                                            target='_blank'
                                            className="file__link"
                                        >
                                            {el.project.name}
                                        </Link>
                                    </td>
                                    <td>{el.emps}</td>
                                    <td>{el.poses}</td>
                                    <td>{el.routes}</td>
                                    <td>{el.manager}</td>
                                    <td>
                                        {el?.activated ? formatDateWithDots(el?.activated) : ""}
                                    </td>
                                </tr>
                            ))}
                            </tbody>

                            {data?.length > 0 && (
                                <tfoot className={styles.tFooter}>
                                <tr>
                                    <td></td>
                                    <td>
                                        <span>Итого:</span>
                                    </td>

                                    <td>
                                        <span>{totalEmps}</span>
                                    </td>

                                    <td>
                                        <span>{totalPoses}</span>
                                    </td>

                                    <td colSpan={3}>
                                        <span>{totalRoutes}</span>
                                    </td>
                                </tr>
                                </tfoot>
                            )}
                        </table>
                    </div>
                </div>
                <div className="pagination">
                    <div className="pagination__count">Всего: {count}</div>
                    <div className="pagination__str">
                        <span>Отображать строки</span>
                        <LimitSelect limit={actualLimit} propsChange={handleChangeLimits}/>
                    </div>
                    <Pagination
                        setCurrentPage={setCurrentPage}
                        setStartPage={setStartPage}
                        handleChange={handleChange}
                        currentPage={currentPage}
                        startPage={startPage}
                        count={count}
                        limit={actualLimit}
                        pageName="userReports"
                    />
                </div>
            </div>
        </>
    );

};

export default TableConsolidatedBudget;
